<template>
  <v-card class="pa-5 ma-5">
    <v-card-title>
      <v-spacer></v-spacer>
      <v-btn rounded color="primary" class="ma-2" @click="saveBuilding" :disabled="disabled">
        <v-icon class="pr-2">mdi-content-save</v-icon>
        Save
      </v-btn>
      <v-btn rounded color="primary" class="ma-2" @click="removeBuilding" :disabled="disabled">
        <v-icon class="pr-2">mdi-delete</v-icon>
        Delete
      </v-btn>
    </v-card-title>
    <v-row>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-model="building.name"
              label="Name of the Building"
              :disabled="disabled"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-select
              v-model="building.construction"
              :items="options.constructions"
              clearable
              label="Year of Original Construction."
              :disabled="disabled"
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-select
              v-model="building.upgrade"
              :items="options.upgrades"
              clearable
              label="Year of most recent structural upgrades i.e. roof
              replacement and upgrades to the roof structure."
              :disabled="disabled"
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="building.storeys"
              label="Number of storeys above the ground or any basement."
              type="number"
              :disabled="disabled"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-select
              v-model="building.basement"
              :items="options.binary0"
              label="Does the building have a basement?"
              single-line
              :disabled="disabled"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-row>
  </v-card>
</template>

<script>
import { router } from "../router";
import { answers } from "../helpers";

export default {
  name: "Building",
  props: ["building", "site"],

  data: () => ({
    options: answers,
    disabled: false
  }),

  mounted() {
    if (this.site.inspection_status.toString() !== "P" ){
      this.disabled = true;
    }
  },
  methods: {
    removeBuilding(){
      const siteId = this.site.id;
      const buildingId = this.building.id;
      this.$store.dispatch("sites/deleteBuilding", { site: siteId, building: buildingId} );
    },
    saveBuilding(){
      const building = this.building;
      this.$store.dispatch("sites/saveBuilding", { building: building} );
    }

  }
};
</script>
